import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import {
  Button,
  ButtonGroup,
  DropdownButton,
  Modal,
} from 'react-bootstrap';
import * as Fi from 'react-icons/fi';

import { ReceivingPlan, Table } from 'services/action';

const initialState = {
  showDelete: false,
  showComplete: false,
};

const Action = ({ data }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state.Form);

  const StateTable = useSelector((state) => state?.Table?.data['receivingPlan']);

  const [{ showDelete, showComplete }, setState] =
    React.useState(initialState);

  const $handleClose = () => {
    setState((prevState) => ({ ...prevState, showDelete: false, showComplete: false }));
  };

  const $handleDelete = async () => {
    const del = await Dispatch(ReceivingPlan.$delete(data?.id));
    if (del?.message === 'success') {
      $handleClose();
      Dispatch(Table.$reload('receivingPlan', StateTable));
    }
  };

  const $handleComplete = async () => {
    const req = await Dispatch(ReceivingPlan.$complete(data?.id));
    if (req?.message === 'success') {
      $handleClose();
      Dispatch(Table.$reload('receivingPlan', StateTable));
    }
  };

  return (
    <>
      <DropdownButton
        as={ButtonGroup}
        variant="transparent"
        size="md"
        className="no-carret tbl-action"
        title={<Fi.FiMoreVertical size={13} color="gray" />}
      >
        <Link
          className="dropdown-item d-flex align-items-center"
          role="button"
          to={`/receiving/plan/${data?.id}`}
        >
          <Fi.FiClipboard size={15} color="#202020" className="me-2" />
          Detil
        </Link>

        {data?.document_status === 'new' && (
          <>
            <Link
              className="dropdown-item d-flex align-items-center"
              role="button"
              to={`/receiving/receive/${data?.id}/update`}
            >
              <Fi.FiEdit size={15} color="#202020" className="me-2" />
              Perbaharui
            </Link>
            <button
              className="dropdown-item d-flex align-items-center"
              onClick={() =>
                setState((prevState) => ({ ...prevState, showDelete: true }))
              }
            >
              <Fi.FiTrash2 size={15} className="me-2" />
              Hapus
            </button>
          </>
        )}

        {data?.document_status === 'active' && (
          <>
            <Link
              className="dropdown-item d-flex align-items-center"
              role="button"
              to={{
                pathname: '/receiving/receive/create',
                state: { plan: data?.id },
              }}
            >
              <Fi.FiCheckCircle size={15} className="me-2" />
              Terima Barang
            </Link>
            <button
              className="dropdown-item d-flex align-items-center"
              onClick={() =>
                setState((prevState) => ({ ...prevState, showComplete: true }))
              }
            >
              <Fi.FiCheckCircle size={15} className="me-2" />
              Complete
            </button>
          </>
        )}
      </DropdownButton>

      {/* modal delete */}
      <Modal
        show={showDelete}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
            <h3>Anda yakin?</h3>
            <p className="text-danger fw-semibold">
              Data yang sudah dihapus tidak bisa dipulihkan
            </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button
                variant="white"
                className="w-100"
                onClick={$handleClose}
              >
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={
                  StateForm?.loading ? ' btn-loading w-100' : 'w-100'
                }
                onClick={$handleDelete}
                disabled={StateForm?.loading}
              >
                Hapus
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* modal complete */}
      <Modal
        show={showComplete}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-info" />
          <Fi.FiAlertTriangle className="mb-2 text-info" size={90} />
            <h3>Anda yakin?</h3>
            <p className="text-info fw-semibold">
              Rencana penerimaan tidak dapat diterima lagi, apabila sudah diselesaikan
            </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button
                variant="white"
                className="w-100"
                onClick={$handleClose}
              >
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="info"
                className={
                  StateForm?.loading ? ' btn-loading w-100' : 'w-100'
                }
                onClick={$handleComplete}
                disabled={StateForm?.loading}
              >
                Ya
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
};

export default Action;
